export const ANNUAL_WHEEL_13_LAYOUT = {
    id: 'annual-wheel-13',
    family: 'wheel',
    cards: 13,
    description: 'Ruota annuale con significatore centrale e dodici mesi disposti in ciclo.',
    supports_focus_overlay: true,
    variants: [
        {
            id: 'portrait',
            points: [
                { x: 50, y: 50, z: 3 },
                { x: 50, y: 12, z: 1 },
                { x: 68, y: 16, z: 1 },
                { x: 82, y: 28, z: 1 },
                { x: 88, y: 46, z: 1 },
                { x: 82, y: 64, z: 1 },
                { x: 68, y: 78, z: 1 },
                { x: 50, y: 84, z: 1 },
                { x: 32, y: 78, z: 1 },
                { x: 18, y: 64, z: 1 },
                { x: 12, y: 46, z: 1 },
                { x: 18, y: 28, z: 1 },
                { x: 32, y: 16, z: 1 },
            ],
        },
        {
            id: 'compact',
            points: [
                { x: 50, y: 52, z: 3 },
                { x: 50, y: 18, z: 1 },
                { x: 66, y: 22, z: 1 },
                { x: 78, y: 32, z: 1 },
                { x: 84, y: 48, z: 1 },
                { x: 78, y: 64, z: 1 },
                { x: 66, y: 74, z: 1 },
                { x: 50, y: 78, z: 1 },
                { x: 34, y: 74, z: 1 },
                { x: 22, y: 64, z: 1 },
                { x: 16, y: 48, z: 1 },
                { x: 22, y: 32, z: 1 },
                { x: 34, y: 22, z: 1 },
            ],
        },
    ],
};
//# sourceMappingURL=annual-wheel-13.js.map